import { all, call, fork, put, takeEvery } from 'bukku/shared/SagaService';
import actions from './actions';
import {get} from 'bukku/shared/ApiService';

import {errorSagaFn, requestSagaPullingFn, successSagaFn} from "../helper";
import { dummyAddOnPacks, dummyQuotas, useDummyAddonPacks, useDummyQuotas } from './dummyData';

const successKeys = [
    actions.READ_QUOTAS_SUCCESS,
    actions.READ_ADD_ON_PACKS_SUCCESS,
];
const getSuccessMsg = () => null;

const errorKeys = [
    actions.READ_QUOTAS_ERROR,
    actions.READ_ADD_ON_PACKS_ERROR,
];

export function* readQuotasRequest() {
    yield takeEvery(actions.READ_QUOTAS_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* () {
                let data;
                if (!useDummyQuotas) {
                    const response = yield call(get, '/quotas', null, context);
                    data = yield response.data;
                }
                else {
                    data = dummyQuotas;
                }

                // OK
                yield put({
                    type: actions.READ_QUOTAS_SUCCESS,
                    quotas: data.quotas,
                });
            },
        );
    });
}

// READ All Available Add On Packs
export function* readAddOnPacksRequest() {
    yield takeEvery(actions.READ_ADD_ON_PACKS_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* () {
                let data;
                if (!useDummyAddonPacks) {
                    const response = yield call(get, '/addon_packs', {
                        include_new: true,
                    }, context);
                    data = yield response.data;
                }
                else {
                    data = dummyAddOnPacks;
                }

                yield put({
                    type: actions.READ_ADD_ON_PACKS_SUCCESS,
                    addonPacks: data.addon_packs,
                });
            });
    });
}

export default function* rootSaga() {
    yield all([
        fork(successSagaFn(successKeys, getSuccessMsg)),
        fork(errorSagaFn(errorKeys)),
        fork(readQuotasRequest),
        fork(readAddOnPacksRequest),
    ]);
}
